import cx from "clsx";
import * as React from "react";

import Flex from "../Flex";

import styles from "./index.module.scss";

const COLOR = {
  normal: styles.colorNormal,
  error: styles.colorError,
};

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  label: string;
  value: string;
  onChange?: (value: string) => void;
  multiline?: number;
  disabled?: boolean;
  color?: keyof typeof COLOR;
  slotRight?: React.ReactNode;
};

type ForwardedProps = React.HTMLAttributes<HTMLDivElement>;

type Props = OwnProps & Omit<ForwardedProps, keyof OwnProps>;

export default function Input({
  className,
  style,
  label,
  value,
  onChange,
  multiline,
  disabled,
  color = "normal",
  slotRight,
  ...others
}: Props) {
  const id = React.useId();
  const Component = multiline ? "textarea" : "input";

  return (
    <div
      className={cx(
        styles.container,
        className,
        disabled ? styles.disabled : null,
        COLOR[color]
      )}
      style={style}
      {...others}
    >
      <fieldset className={styles.fieldset}>
        <legend className={styles.legend}>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
        </legend>
        <Flex.Row padding="6px 24px 16px 24px" gap="8px">
          <Component
            id={id}
            className={styles.input}
            style={{ flex: "1 1 0" }}
            value={value}
            onChange={(event) => {
              const value = event.target.value;
              onChange?.(value);
            }}
            rows={multiline || undefined}
            disabled={disabled}
          />
          {slotRight ? (
            <Flex.Row
              flex="0 0 auto"
              alignItems="center"
              justifyContent="center"
            >
              {slotRight}
            </Flex.Row>
          ) : null}
        </Flex.Row>
      </fieldset>
    </div>
  );
}
